import { Routes } from '@angular/router';
import { LandingPageComponent } from './features/landing/landing-page/landing-page.component';

export const routes: Routes = [
    {
        path: '', component: LandingPageComponent, children: [
            { 
                path: '',
                loadComponent: () => import('./features/landing/pages/main/main.component')
                .then(m => m.MainComponent)
            },
            {
                path: 'gallery', 
                loadComponent: () => import('./features/landing/pages/gallery/gallery.component')
                .then(m => m.GalleryComponent)
            },
            { 
                path: 'voices/:id', 
                loadComponent: () => import('./features/landing/pages/voice/voice.component')
                    .then(m => m.VoiceComponent) 
            },
            {
                path: 'submit',
                loadComponent: () => import('./features/landing/pages/form/form.component')
                    .then(m => m.FormComponent)
            },
            {
                path: 'about-us',
                loadComponent: () => import('./features/landing/pages/about-us/about-us.component')
                    .then(m => m.AboutUsComponent)
            },
            {
                path: 'get-involved',
                loadComponent: () => import('./features/landing/pages/get-involved/get-involved.component')
                    .then(m => m.GetInvolvedComponent)
            },
            {
                path: 'spots',
                loadComponent: () => import('./features/landing/pages/spots/spots.component')
                    .then(m => m.SpotsComponent)
            },
            {
                path: 'blog',
                loadComponent: () => import('./features/landing/pages/blog/blog.component')
                    .then(m => m.BlogComponent)
            },
            {
                path: 'blogs/:id', 
                loadComponent: () => import('./features/landing/pages/post/post.component')
                .then(m => m.PostComponent)
            },
            {
                path: 'map',
                loadComponent: () => import('./features/landing/pages/map/map.component')
                    .then(m => m.MapComponent)
            },
            {
                path: 'terms',
                loadComponent: () => import('./features/landing/pages/terms/terms.component')
                    .then(m => m.TermsComponent)
            },
            {
                path: 'privacy',
                loadComponent: () => import('./features/landing/pages/privacy/privacy.component')
                    .then(m => m.PrivacyComponent)
            },
            {
                path: 'browse-requests',
                loadComponent: () => import('./features/landing/pages/browse-requests/browse-requests.component')
                    .then(m => m.BrowseRequestsComponent)
            },
            {
                path: 'request-support',
                loadComponent: () => import('./features/landing/pages/request-support/request-support.component')
                    .then(m => m.RequestSupportComponent)
            },
            {
                path: 'request/:id',
                loadComponent: () => import('./features/landing/pages/request/request.component')
                    .then(m => m.RequestComponent)
            },
            {
                path: 'send-to-anyone',
                loadComponent: () => import('./features/landing/pages/send-to-anyone/send-to-anyone.component')
                    .then(m => m.SendToAnyoneComponent)
            },
            { path: '**', redirectTo: '/blog' }
        ],
    },
];